import { Institution } from '../institution'
import { KeyValueObject } from '@questwork/q-utilities'

const updateAllowedProps = [
  'active',
  'address',
  'firstName',
  'institution',
  'lastName',
  'registrationGroupCodes',
  'title'
]

class Member {
  constructor(options = {}) {
    options = options || {}
    this.id = options.id || options._id
    this._meta = KeyValueObject.initOnlyValidFromArray(options._meta)
    this.active = options.active || false
    this.eventRegistrationCode = options.eventRegistrationCode
    this.created = options.created || (new Date()).valueOf()
    this.creator = options.creator
    this.customFields = KeyValueObject.initOnlyValidFromArray(options.customFields)
    this.deleted = options.deleted || false
    this.displayName = options.displayName || ''
    this.email = options.email
    this.eventShortCode = options.eventShortCode
    this.firstName = options.firstName
    this.institution = Institution.init(options.institution)
    this.lastName = options.lastName || ''
    this.modified = options.modified || (new Date()).valueOf()
    this.registrationDate = options.registrationDate
    this.registrationGroupCodes = options.registrationGroupCodes || []
    this.remarks = KeyValueObject.initOnlyValidFromArray(options.remarks)
    this.tenantCode = options.tenantCode
    this.title = options.title
  }

  // Class methods
  static init(options) {
    if (options instanceof Member) {
      return options
    }
    const instance = new Member(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this.address && !!this.eventShortCode && !!this.email && !!this.firstName && !!this.tenantCode && !!this.title
  }
  get badgeName() {
    return this.meta.badgeName || this.displayName || `${this.firstName} ${this.lastName}`
  }
  get country() {
    return this.address ? this.address.country : null
  }
  get meta() {
    return KeyValueObject.toObject(this._meta)
  }
  // get displayName() {
  //   return `${this.firstName} ${this.lastName}`
  // }

  displayRegistrationGroupCodes() {
    return this.registrationGroupCodes.join(', ')
  }
  isDifferentGroup(groupCode) {
    return this.registrationGroupCodes.length > 0 && !this.registrationGroupCodes.includes(groupCode)
  }
  isSameGroup(groupCode) {
    return this.registrationGroupCodes.includes(groupCode)
  }
  isSameId(id) {
    return this.id === id || this._id === id
  }
  setModified() {
    this.modified = (new Date()).valueOf()
    return this
  }
  update({ name: key, value }) {
    if (key === 'badgeName' || key === 'status') {
      this._meta = KeyValueObject.updateOrInsertRecord(this._meta, key, value)
    } else if (key === 'institution') {
      this.institution.updateInstitution(value)
    } else if (key === 'remarks') {
      this.remarks = KeyValueObject.initOnlyValidFromArray(value)
    } else {
      this[key] = value
    }
  }
  updateMember(update) {
    Object.keys(update).forEach((key) => {
      if (updateAllowedProps.includes(key)) {
        if (key === 'institution') {
          this.institution.updateInstitution(update[key])
        } else if (key === 'remarks') {
          this.remarks = KeyValueObject.initOnlyValidFromArray(update[key])
        } else {
          this[key] = update[key]
        }
      }
    })
    return this.setModified()
  }
  validateName(countries) {
    return !!this.firstName && this.validateLastName(countries)
  }
  validateLastName(countries) {
    return allowNoLastName(this.country, countries) ? true : !!this.lastName
  }
  validateCountry(countries) {
    return validateCountry(this.country, countries)
  }

  validateEmail() {
    return this
  }

  validateTitle() {
    return this
  }
}

function allowNoLastName(country, countries) {
  const isCountryCode = country.length === 2
  const found = (countries || []).find((c) => {
    return isCountryCode
      ? c.code === country
      : c.name === country
  })
  return found ? found.allowNoLastName : false
}

function validateCountry(country, _countries) {
  return !!(_countries || []).find((c) => {
    return c.code === country
  })
}

export default {
  Member
}
export {
  Member
}
